<div class='container-fluid contentMarginCMS'>
  <div class='row m-0'>
    <div class='col-12 col-sm-3 col-lg-2 m-0 p-0 h-100 collapse show mt-3' id='collapseExample'>
      <nav class='nav flex-column sticky-top'>
        <li class='nav-item'>
          <a class='nav-link dashboard backPrimary' [routerLink]="['/settings']">
            <i class='fa fa-list-alt me-1' aria-hidden='true'></i>Settings</a>
        </li>
        <li class='nav-item'>
          <a class='nav-link dropdown-toggle flex-nowrap bottomlinegray' data-bs-toggle='collapse' data-bs-target='#item-1' aria-expanded='true' aria-controls='item-1'>My
            Account</a>
          <div id='item-1' class='collapse show' data-bs-parent='null'>
            <ul class='nav flex-column'>
              <li class='nav-item'>
                <a class='nav-link ps-5 ' (click)='openProfileModal()'>Profile</a>
              </li>
            </ul>
            <ul class='nav flex-column'>
              <li class='nav-item'>
                <a *ngIf='canShowSubscription()' class='nav-link ps-5 '
                   [routerLink]="['/settings/subscription']">Subscription</a>
              </li>
            </ul>
          </div>
        </li>
      </nav>
    </div>
    <div class='col-12 col-sm-9 col-lg-10 p-0'>
      <div class='row m-0'>
        <div class='col-12 pe-0'>
          <h3 class='sticky-top mt-3'> {{ settingsTitle }}</h3>
        </div>
        <div class='col-12 pe-0'>
          <hr />
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>
</div>

